<template>
    <div id="todo-app" class="coo-app border border-solid d-theme-border-grey-light rounded relative overflow-hidden">
        <vue-headful :title="$t('coo_title')" />

        <vs-sidebar class="items-no-padding" parent="#todo-app" :click-not-close="clickNotClose" :hidden-background="clickNotClose" v-model="isSidebarActive">

            <!-- ФУНКЦИОНАЛ СОЗДАНИЯ -->
            <AddCoo ref="addComponents" @closeopensidebar="closeViewSidebar" :itemHandler="infiniteHandle" />

            <!-- ФИЛЬТРЫ -->
            <ListFilters :sidebarToggle="toggleSidebar" ref="ListFilters" :itemHandler="infiniteHandle" @closeopensidebar="closeViewSidebar" />

        </vs-sidebar>
        <div :class="{'sidebar-spacer': clickNotClose}" class="no-scroll-content border border-r-0 border-b-0 border-t-0 border-solid d-theme-border-grey-light no-scroll-content">

            <!-- header -->
            <div class="emc__actions flex items-center flex-wrap justify-between">
                <feather-icon class="cursor-pointer emc_mobile_sidebar md:inline-flex lg:hidden ml-4 mr-4" icon="MenuIcon" @click.stop="toggleSidebar(true)" />
            </div>

            <!-- СПИСОК -->
            <component
                :is="'VuePerfectScrollbar'"
                class="infinite_scroll_wrapper"
                ref="requestListScroll"
                :settings="settings"
                @ps-y-reach-end="infiniteHandle"
                :key="$vs.rtl">

                <ul v-if="requestList.length">
                    <li
                        class="todo_todo-item cursor-pointer"
                        @click="openListItem(item)"
                        v-for="(item, index) in requestList"
                        :style="[{transitionDelay: (index * 0.1) + 's'}]"
                        :key="`r_${ index }`">
                            <ItemList :item="item" />
                    </li>
                </ul>

                <div class="mt-4 ml-5 mr-5" v-if="emptyMessage">
                    <vs-alert active="true">
                        {{$t('no_data_text')}}
                    </vs-alert>
                </div>

                <!-- В этот див выводил лоадер -->
                <div id="infinite_loader" class="vs-con-loading__container"></div>

            </component>
        </div>

        <!-- Просмотр элемента -->
        <ItemView
            :itemHandler="infiniteHandle"
            @closesidebar="closeViewSidebar"
        />
    </div>
</template>

<script>
import coo from '@/store/modules/coo.js'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import ListFilters from './ListFilters'
import AddCoo from './AddCoo'
import ItemList from './ItemList'
import ItemView from './ItemView'
import {  mapMutations } from "vuex"
import CooMixin from "./CooMixin";
const payloadParams = (payload) => {
    if(payload) {
        let reqData = "";
        Object.keys(payload).forEach(key => {
            reqData += key + "=" + payload[key] + "&"
        })
        reqData = reqData.substr(0, reqData.lastIndexOf("&"))
        return '?'+reqData
    } else return ''
}

export default {
    data() {
        return {

            isSidebarActive: true,
            clickNotClose: true,
            loading: false,
            emptyMessage: false,
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.60
            }
        }
    },
    mixins:[CooMixin],
    components: {
        VuePerfectScrollbar,
        ListFilters,
        AddCoo,
        ItemList,
        ItemView
    },
    watch: {

        windowWidth () {
            this.setSidebarWidth()
        },

    },
    created () {
        this.setSidebarWidth()
        this.CREATE_MUT()

        if(this.$route.query.full_name_with_id){
            this.$route.meta.pageTitle = this.$t('coo') + '. ' + this.$route.query.full_name_with_id
        }else {
            this.$route.meta.pageTitle = 'coo_title'
        }
    },

    computed: {
        windowWidth () { return this.$store.state.windowWidth },
        requestList() {
            return this.$store.state.coo.requestList
        },
        page: {
            get() {
                return this.$store.state.coo.page
            },
            set(value) {
                this.$store.commit("coo/SET_PAGE", value)
            }
        },
        infiniteStatus: {
            get() {
                return this.$store.state.coo.infiniteStatus
            },
            set(value) {
                this.$store.commit("coo/SET_INF_STATUS", value)
            }
        },
        isViewSidebarActive: {
            get() {
                return this.$store.state.coo.isViewSidebarActive
            },
            set(value) {
                this.$store.commit("coo/SET_IS_VIEW_SIDEBAR_ACTIVE", value)
            }
        },
    },
    methods: {
        ...mapMutations({
            CREATE_MUT:'coo/CREATE_MUT'
        }),
        async openListItem(item) {
            try {
                this.$vs.loading({
                    container: `.coo-card-${ item.uid }`,
                    scale: 0.45
                })

                const res = await this.$store.dispatch('coo/getOpenItem', item)
            } catch(e) {
                this.$vs.notify({
                    text: this.$t('error'),
                    color: 'danger'
                })
            } finally {
                this.$vs.loading.close(`.coo-card-${ item.uid } > .con-vs-loading`)
                this.isViewSidebarActive = true
            }
        },
        closeViewSidebar() {
            // Закрываем окно просмотра элемента
            this.isViewSidebarActive = false

            //
            this.$store.commit('coo/SET_OPEN_ITEM', null)
        },
        infiniteHandle({update = false}) {
            if(update) {
                this.infiniteStatus = true
                this.page = 0
                this.$store.commit('coo/CLEAR_REQUEST_LIST')
            }
            this.requestListHandler()
        },
        async requestListHandler() {
            if(!this.loading && this.infiniteStatus) {
                this.loading = true
                this.emptyMessage = false
                this.$nextTick(() => {
                    this.$vs.loading({
                        container: '#infinite_loader',
                        scale: 0.6
                    })
                })

                try {
                    this.page = this.page+1
                    const res = await this.$store.dispatch('coo/fetchRequest', {page: this.page, ...this.$route.query, profile:this.getProfileUidFromKey('profile')})

                    if(!res || this.page === 1 && !res.results.length) this.emptyMessage = true

                    // Если запросили последнюю страницу, меняем статус инфинити скролла
                    if(!res || !res.next) this.infiniteStatus = false
                } catch(e) {
                    console.error(e);
                    this.$vs.notify({
                        text: this.$t('error'),
                        color: 'danger'
                    })
                } finally {
                    this.loading = false
                    this.$vs.loading.close('#infinite_loader > .con-vs-loading')
                }
            }
        },
        setSidebarWidth () {
            if (this.windowWidth < 992) {
                this.isSidebarActive = this.clickNotClose = false
            } else {
                this.isSidebarActive = this.clickNotClose = true
            }
        },
        toggleSidebar (value = false) {
            // Функция открытия sidebar с фильтрами для моб устройств
            if (!value && this.clickNotClose) return
            this.isSidebarActive = value
        }
    }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/todo.scss";
@media only screen and (min-width: 993px) {
    .coo-app{
        .vs-sidebar-position-right{
            max-width: calc(100% - 260px)!important;
        }
    }
}
#infinite_loader{
    padding: 20px 0;
    .con-vs-loading{
        background: transparent;
    }
}
.coo-app{
    .infinite_scroll_wrapper{
        height: 100%;
    }
    .filters_scroll_area{
        height: calc(100% - 67px);
    }
}
</style>
